import { ViewModel } from '../view-model';

export class CommercialImpactInput implements ViewModel {
  friendlyTypeNameSingular: string = 'Commercial Impact Input';
  apiRoute: string;

  id: string;
  description: string;
  quantity: number;
  impact: number;
  unitsPerHour: number;
  valuePerUnit: number;
  valuePerHour: number;
  // This is a calculated field and as such isn't saved on the backend, it's only used for display
  totalCost: number;
  commercialImpactItemId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.description = data.description;
    this.quantity = data.quantity;
    this.impact = data.impact;
    this.unitsPerHour = data.unitsPerHour;
    this.valuePerUnit = data.valuePerUnit;
    this.valuePerHour = data.valuePerHour;
    this.commercialImpactItemId = data.commercialImpactItemId;
  }
}
